export default "__VITE_ASSET__C$lpe3QO__"